import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=3541de3e&scoped=true"
import script from "./VideoSlide.vue?vue&type=script&lang=js"
export * from "./VideoSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541de3e",
  null
  
)

export default component.exports